<template lang="pug">
div
    Card.a8-page-description-card
        h2 {{$t("frontends.pageTitleText")}}
        p Manage platform frontend setting.
        Row(type="flex" justify="end" align="middle" v-show="isShowSaveBtn")
            Col
                Button(type="primary" @click="updateData") {{ $t("rcmtable.saveText") }}
    Card.a8-page-description-card
        div(slot="title")
            p {{$t("frontends.bulletinTitleText")}}
        Form(:model="frontendConfigs" :label-width="150")
            FormItem(:label='$t("frontends.isShowBulletinBoard")')
                i-switch(v-model="frontendConfigs.isShowBulletinBoard" size="large")
            FormItem(:label='$t("frontends.userGuideText")')
                Input(v-model="frontendConfigs.userGuideUrl" placeholder="Enter user guide url")
            FormItem(:label='$t("frontends.sendMailToAdmin")')
                Input(v-model="frontendConfigs.adminMail" placeholder="Enter user admin mail")
            FormItem(:label='$t("frontends.bulletin")')
                Input(v-model="frontendConfigs.announcement[$store.state.userPref.lang]" type="textarea" :autosize="{minRows: 5,maxRows: 5}")
        Row(type="flex" justify="end" align="middle" )
            Col
                h3 Platform Plan: {{ platformPlan }}
                p Frontend version : {{ appVersion }}
                p Project version : {{ projectVersion }}
</template>
<script>
import { getSystemFrontendConfig, updateSystemFrontendConfig } from "@/api/system";

export default {
    name: "FrontEndSetting",
    props: [],
    data() {
        return {
            frontendConfigs: this.$store.state.frontendConfigs,
            appVersion: process.env.VUE_APP_VERSION,
            projectVersion: process.env.PROJECT_VERSION,
            platformPlan: this.$store.state.platformPlan.currentPlan,
            isShowSaveBtn: false,
        };
    },
    methods: {
        updateData() {
            updateSystemFrontendConfig(this.frontendConfigs)
                .then((response) => {
                    if (!response.data.success) throw new Error(response.data.message);
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${response.data.message}`,
                    });
                    this.isShowSaveBtn = false;
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
    },
    async created() {
        const getFrontendConfig = await getSystemFrontendConfig();
        if (JSON.stringify(getFrontendConfig.data) != JSON.stringify(this.frontendConfigs)) {
            this.isShowSaveBtn = true;
        }
    },
    watch: {
        frontendConfigs: {
            deep: true,
            handler: function (newVal) {
                this.isShowSaveBtn = true;
                this.$store.commit("SET_FRONTEND_CONFIGS", newVal);
            },
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/system/FrontEndSetting.vue